import { BodyText, Button, ButtonProps, Heading, Modal } from '@farol-ds/react'
import { Image } from '@jusbrasil-web/shared-next-image'
import { ReactNode } from 'react'

import { useValidateOabModalContext } from '../../context'
import erroSvg from '../../images/erro.svg'
import styles from '../steps.module.scss'

export function ValidatingError() {
  const context = useValidateOabModalContext()
  const { resetToInitialStep, goNextSuccessStep, errorKey, emailConflicted, errorMessage } = context

  let mainText: ReactNode
  let reviewButtonKind: ButtonProps['kind']
  let nextButton: ReactNode

  if (errorKey === 'DUPLICATED_VALIDATION_ERROR') {
    mainText = (
      <>
        Para continuar, acesse o Jusbrasil com a conta <strong>{emailConflicted}</strong> ou
        cadastre esta OAB à conta atual.
        <br />
        <br />
        Caso não reconheça essa conta, ou esteja sem acesso a ela,
      </>
    )
    reviewButtonKind = 'secondary'
    nextButton = (
      <Button onClick={goNextSuccessStep} kind="primary">
        Cadastrar OAB à conta atual
      </Button>
    )
  } else {
    mainText = <>Por favor, revise suas informações ou</>
    reviewButtonKind = 'primary'
  }

  return (
    <>
      <Modal.IconClose />
      <Modal.Body className={styles.infoModalBody}>
        <Image src={erroSvg} width={140} height={140} loading="lazy" alt="" />
        <Heading className={styles['infoModalBody-heading']}>{errorMessage}</Heading>
        <BodyText className={styles['infoModalBody-bodyText']}>
          {mainText} entre em{' '}
          <a
            href="https://suporte.jusbrasil.com.br/hc/pt-br/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            contato com o suporte.
          </a>
        </BodyText>
      </Modal.Body>
      <Modal.Footer>
        {nextButton}
        <Button onClick={resetToInitialStep} kind={reviewButtonKind}>
          Revisar informações
        </Button>
      </Modal.Footer>
    </>
  )
}
